module.exports = __webpack_public_path__ + "img/close-rounded.0c79ac51.svg";